/* src/app/shared/components/ag-date-picker/date-regular-box/date-regular-box.component.scss */
.custom-datepicker {
  position: absolute;
  z-index: 4;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #222222;
  padding: 16px;
  overflow: hidden;
}
.placement-top {
  bottom: 0px;
}
.placement-bottom {
  top: 0px;
}
.placement-right {
  right: 101%;
}
.placement-zero-right {
  right: 0%;
}
.placement-zero-left {
  left: 0%;
}
.placement-left {
  left: 101%;
}
.placement-top-left {
  top: 0px;
  left: 101%;
}
.placement-top-right {
  top: 0px;
  right: 101%;
}
.placement-bottom-left {
  bottom: 52px;
  left: 101%;
}
.placement-bottom-right {
  bottom: 52px;
  left: 101%;
}
.placement-bottom-just-left {
  right: 0;
}
.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.image {
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.label {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
td {
  width: 36px;
  height: 36px;
  margin: 2px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}
td:not(:has(.in-month)):hover {
  cursor: default;
  background: transparent;
}
td:hover {
  border-radius: 8px;
  background: #f2f2f2;
}
.no-hover {
  cursor: default;
}
.no-hover:hover {
  background: transparent;
}
th {
  width: 18px;
  height: 18px;
  margin: 7px 9px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.br-line {
  height: 90%;
  left: 33px;
  top: 24px;
  width: 1px;
  background: #dfdfdf;
  position: absolute;
  z-index: 2;
}
.button-area {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 8px;
  padding-top: 24px;
}
.calendar {
  position: relative;
  padding-top: 24px;
  overflow: hidden;
}
.week {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  line-height: 18px;
  color: #a6a6a6;
  margin: 0;
}
.not-in-month {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #a6a6a6;
  margin: 0;
}
.in-month {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
  margin: 0;
}
.first-last-date {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  margin: 0;
  background-color: #222222 !important;
  color: #ffffff;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border-top: 1px solid #222222;
  border-bottom: 1px solid #222222;
}
.first-date {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  margin: 0;
  background-color: #222222 !important;
  color: #ffffff;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  padding: 0;
  width: 36px;
  height: 36px;
}
.last-date {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  margin: 0;
  background-color: #222222 !important;
  color: #ffffff;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #222222;
  padding: 0;
  width: 36px;
  height: 36px;
}
.first-date {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background-color: #f2f2f2;
  padding: 0;
}
.last-date {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #f2f2f2;
  padding: 0;
}
.white {
  color: #ffffff !important;
}
.selected {
  background-color: #e4d7f3;
}
/*# sourceMappingURL=date-regular-box.component.css.map */
